module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-05.16544dd9.jpg";